import BoxListing from "./boxListing.container";

export default BoxListing;
